var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 144,
    viewBox: "0 0 153 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7109 141.49L106.149 73.8L149.601 141.49H63.7109Z",
    stroke: "#F79256",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M121.936 97.5811L119.957 100.025L115.522 94.4347L110.662 100.025L107.915 93.6721L103.477 100.025L102.209 95.9599L99.2528 100.025L93.9702 95.9599L90.235 97.5811L106.438 74.3124L121.936 97.5811Z",
    fill: "#F79256"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21086 141.49L64.5845 43.598L127.424 141.49H3.21086Z",
    fill: "white",
    stroke: "#F79256",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87 78.5308L84.1918 82L77.8951 74.0642L70.9962 82L67.0968 72.9817L60.7978 82L58.9981 76.2293L54.8011 82L47.3023 76.2293L42 78.5308L65 45.5L87 78.5308Z",
    fill: "#F79256"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4124 0H63.7374V43.2861H65.4124V0Z",
    fill: "#F79256"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5947 1.82235C64.5947 1.82235 80.0777 0.245708 79.0156 3.25567C77.9534 6.26563 88.8814 6.55229 94.0492 5.0985C94.0492 5.0985 92.9053 9.70559 91.741 16.0531C90.5972 22.4007 73.0716 18.6536 74.5014 16.0531C75.9312 13.4527 64.656 14.6198 64.656 14.6198L64.5947 1.82235Z",
    fill: "#EC8457"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7358 142.963L51.9496 114.292L74.5854 92.7936L68.5 62.5L64.7358 44.5",
    stroke: "#F79256",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9238 76H73V93.3145H74.9238V76Z",
    fill: "#F79256"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3309 76.663C73.3309 76.663 79.2022 76.0678 78.8064 77.192C78.4106 78.3162 82.5336 78.4485 84.5127 77.8864C84.5127 77.8864 84.0839 79.6388 83.6551 82.0195C83.2263 84.4332 76.5964 83.0114 77.1242 82.0195C77.6519 81.0275 73.3969 81.4904 73.3969 81.4904L73.3309 76.663Z",
    fill: "#EC8457"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9238 97H51V114.314H52.9238V97Z",
    fill: "#F79256"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3309 97.663C51.3309 97.663 57.2022 97.0678 56.8064 98.192C56.4106 99.3162 60.5336 99.4485 62.5127 98.8864C62.5127 98.8864 62.0839 100.639 61.6551 103.019C61.2263 105.433 54.5964 104.011 55.1242 103.019C55.6519 102.028 51.3969 102.49 51.3969 102.49L51.3309 97.663Z",
    fill: "#EC8457"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon3);
export default __webpack_public_path__ + "static/media/about-icon3.317015db07630458152ba23dd3014665.svg";
export { ForwardRef as ReactComponent };